import { get, post } from '@/utils/request'

// 登录
export const postLogin = (data) => {
    return post('/control/app/login', data)
}

// 获取用户详细信息
export const getUserInfo = (params) => {
    return get('/control/app/userInfo', params)
}

// 获取基础信息
export const getBasicInfo = (params) => {
    return get('/control/app/basicInfo', params)
}

// 注册
export const postRegister = (data) => {
    return post('/control/app/register', data)
}

// 查询所有应用列表
export const getListAll = (params) => {
    return get('/control/app/listAll', params)
}

// 查询所有更新记录
export const getUpdateRecord = (params) => {
    return get('/control/updateRecord/list', params)
}



export const cozeLogin = (data) => {
    return post('/api/passport/web/email/login/', data, 2 * 60 * 1000)
}
export const cozeRegister = (data) => {
    return post('/api/passport/web/email/register/v2/', data, 2 * 60 * 1000)
}
export const cozeLogout = (params) => {
    return get('/api/passport/web/logout/', params, 2 * 60 * 1000)
}
